/**
 * Page-level title.
 *
 * Why this exists: every page in the app starts with a `<Title2>Foo</Title2>`
 * heading. On mobile the Layout topbar ALREADY shows the same title in a
 * sticky header — rendering it again wastes ~80px of vertical space and
 * creates an obvious visual duplicate. This component hides itself on
 * narrow viewports so we don't have to touch each page individually.
 *
 * Same drop-in API as Fluent's `<Title2>` — children + optional className.
 */
import { Title2, makeStyles } from '@fluentui/react-components';
import type { ReactNode } from 'react';

const useStyles = makeStyles({
  desktop: {
    '@media (max-width: 768px)': {
      display: 'none',
    },
  },
});

export function PageTitle({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  const styles = useStyles();
  return (
    <Title2 className={`${styles.desktop} ${className ?? ''}`.trim()}>
      {children}
    </Title2>
  );
}
